// this is an autogenerated file from DesignSystem/TasksCreateForm/Actions/Content/LetterPredefined/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksCreateForm_Actions_Content_LetterPredefined($id: uuid!) {
  vaxiom_document_tree_nodes(where: { _id: { _eq: $id } }) {
    id
    _id
    name
  }
}

`